import { RouteInfo } from "./sidebar.metadata";
export const ROUTES: RouteInfo[] = [
  {
    path: "dashboard",
    title: "Bienvenido",
    moduleName: "dashboard",
    iconType: "material-icons-two-tone",
    icon: "event_note",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    submenu: [],
  },
  {
    path: "/authentication/signin",
    title: "Logout",
    moduleName: "logout",
    iconType: "material-icons-two-tone",
    icon: "power_settings_new",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    submenu: [],
  },
];
